import AssignmentFilter from "../Components/AssigmentFilter";
import Gallery from "../Components/Gallary";
import ContinentSelector from "../Components/Report&service/ContinentSelector";
import ReportsPagination from "../Components/Report&service/Report";
import CarouselComponent from "../Components/Work/CarouselComponent";
import { BackgroundBeams } from "../Components/ui/background-beams";
import WorldPresence from "../Components/world";
const Work = () => {
  return (
    <div className="mt-5">
      {/* <BackgroundBeamsComponent /> */}
      {/* <Line/> */}
      <div className="py-10 w-full bg-gradient-to-b from-white to-gray-100 relative flex flex-col items-center justify-center antialiased">
        <div className="w-full p-4 flex flex-col justify-center items-center">
          {/* Title */}
          <h1 className="relative z-10  text-2xl md:text-4xl bg-clip-text text-transparent bg-gradient-to-b from-base_500 to-base_600 text-center font-sans font-bold">
          Our Services and Work
          </h1>

          {/* Subtitle */}
          <p className="text-neutral-500 max-w-lg mx-auto my-2 text-md text-center relative z-10">
          Our team of experts provide a wide range of services in research, evaluation and institutional capacity building areas to help you achieve your goals.
          </p>

          {/* Form */}
          <AssignmentFilter/>
                  </div>

        {/* Background Beams */}
        <BackgroundBeams />
      </div>
      
      <div className="h-0.5 bg-gradient-to-t from-purple-800 to-violet-700"></div>
      <CarouselComponent />
      <div className="h-0.5 bg-gradient-to-t from-purple-800 to-violet-700"></div>

      
      <section className="w-full  mt-5 bg-gradient-to-t from-base_500 via-base_600 to-base_500 shadow-lg shadow-base_300 p-6">
        <ReportsPagination />
      </section>
      <section>
       <WorldPresence/>
        <ContinentSelector />
      </section>
      <div className="relative ">
        {/* Watermark */}
      

        {/* Image Gallery */}
        <Gallery />
      </div>
    </div>
  );
};
export default Work;
